(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jbart-home-hero"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

  const hero = document.querySelector('.jb-home-hero');

  if (!hero) return;

  const title = hero.querySelector('.jb-home-hero__title');
  const subtitle = hero.querySelector('.jb-home-hero__subtitle');
  const quote = hero.querySelector('.jb-home-hero__quote');

  [title, subtitle, quote].forEach(element => {
    if (!element) return;

    element.style.opacity = '0';
element.style.transform = 'translateY(50px)';
element.style.filter = 'blur(10px)';
element.style.transition =
  'opacity 1.2s cubic-bezier(.19,1,.22,1), transform 1.2s cubic-bezier(.19,1,.22,1), filter 1.2s cubic-bezier(.19,1,.22,1)';
  });

  setTimeout(() => {
    if (title) {
  title.style.opacity = '1';
  title.style.transform = 'translateY(0)';
  title.style.filter = 'blur(0)';
}
  }, 300);

  setTimeout(() => {
    if (subtitle) {
  subtitle.style.opacity = '1';
  subtitle.style.transform = 'translateY(0)';
  subtitle.style.filter = 'blur(0)';
}
  }, 700);

  setTimeout(() => {
    if (quote) {
  quote.style.opacity = '1';
  quote.style.transform = 'translateY(0)';
  quote.style.filter = 'blur(0)';
}
  }, 1100);

});

// Parallax del video
const heroVideo = document.querySelector('.jb-home-hero__video');

if (heroVideo) {

  window.addEventListener('scroll', () => {

    const offset = window.scrollY * 0.25;

    heroVideo.style.transform = `translateY(${offset}px) scale(1.08)`;

  }, { passive: true });

}

const video = document.querySelector('.jb-home-hero__video');

if (video) {

  video.muted = true;
  video.defaultMuted = true;
  video.playsInline = true;

  const playVideo = () => {
    const promise = video.play();

    if (promise !== undefined) {
      promise.catch(() => {});
    }
  };

  playVideo();

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      playVideo();
    }
  });

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
